import isObject from 'lodash/isObject';

import FieldListEditor from '@/components/ElementListField/FieldListEditor';
import MunicipalitySelect from '@/components/MunicipalitySelect';
import PhoneEditor from '@/components/PhoneNumberField/PhoneEditor';
import ProvinceSelect from '@/components/ProvinceSelect';
import {renderUploadFileDragged} from '@/components/UploadFileDragger';
import {renderActivityPlaceLinkTypeSelect} from '@/modules/activityPlace/components/ActivityPlaceLinkTypeSelect';
import {renderMapViewer} from '@/modules/company/components/OfficeMap/components/MapViewer';
import {useProposalRequestPagination} from '@/modules/proposalRequest/containers/ProposalRequestEntityContainer';
import {handleSocialDenomination} from '@/modules/proposalRequest/hooks/useSocialDenominationType';
import ProposalRequestApiService from '@/modules/proposalRequest/services/ProposalRequestApiService';
import createClearRenderView from '@/utils/createClearRenderView';
import {createRenderRemoteEntity} from '@/utils/createRenderRemoteEntity';
import {createSearchFieldRemote} from '@/utils/createSearchFieldRemote';
import {validations} from '@/utils/fields';

export const fields = [
  {
    key: 'proposal',
    colSpan: 2,
    label: 'proposal',
    renderView: createRenderRemoteEntity({
      service: ProposalRequestApiService.getOne,
      render: createClearRenderView(null, (e) => handleSocialDenomination(e)),
    }),
    widget: createSearchFieldRemote({
      usePagination: useProposalRequestPagination,
      fetchValueFunc: ProposalRequestApiService.getOne,
      fullEntity: true,
      keyLabel: 'socialDenomination',
      size: 10,
      getValue: (value, keyValue) => isObject(value) ? value[keyValue] || value['code'] : value,
      mapResponse: (v) => {
        return v?.map(e => ({
          ...e,
          socialDenomination: handleSocialDenomination(e)
        }));
      }
    }),
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'address.province',
    label: 'province',
    colSpan: 1,
    widget: ProvinceSelect,
    required: true,
  },
  {
    key: 'address.municipality',
    label: 'municipality',
    required: true,
    onlyEdit: true,
    colSpan: 1,
    related: 'address.province',
    relatedKey: 'province',
    widget: MunicipalitySelect
  },
  {
    key: 'address.abstract',
    label: 'address',
    required: true,
    widget: 'textarea'
  },
  {
    key: 'address.location',
    label: 'location',
    onlyEdit: true,
    relatedKey: 'province',
    widgetProps: {
      isOnClickActive: true
    },
    render: ({...rest}) => renderMapViewer(rest, rest?.form.getFieldValue('address.province'))
  },
  {
    key: 'registryCertificate',
    label: 'registryCertificate',
    required: true,
    colSpan: 4,
    render: renderUploadFileDragged,
    widgetProps: {
      isImage: false,
      listType: 'picture',
      fileLabel: 'fileLabel',
      maxCount: 1
    },
  },
  {
    key: 'linkType',
    label: 'linkType.label',
    onlyEdit: true,
    relatedKey: 'linkType',
    required: true,
    render: renderActivityPlaceLinkTypeSelect
  },
  {
    key: 'description',
    label: 'common:description',
    widget: 'textarea',
    widgetProps: {autoSize: {minRows: 5, maxRows: 12}},
    required: false,
    className: 'form-view-mode-vertical-item',
  },
  {
    key: 'phones',
    label: 'phoneNumbers',
    rules: [validations.listPhones()],
    widget: PhoneEditor
  },
  {
    key: 'emails',
    required: false,
    label: 'emails',
    widget: FieldListEditor,
    viewWidgetProps: {
      columns: true
    },
    widgetProps: {
      validations: [{required: false}, {type: 'email'}],
      translate: 'configuration',
      actionText: 'exportEntities.form.emails.addToList'
    },
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'createdAt',
    label: 'createdAt',
    type: 'date',
    onlyView: true,
  },
];
